import * as React from "react";
import "../../styles/contact.css";

type Email = {
  clientEmail: string;
  message: string;
  name: string;
  subject: string;
};

type Response = {
  responseText?: string;
  success?: boolean;
  active: boolean;
};

const Contact: React.FC = () => {
  const [response, setResponse] = React.useState<Response>({
    active: false,
  });

  const [email, setEmail] = React.useState<Email>({
    clientEmail: "",
    message: "",
    name: "",
    subject: "",
  });

  const SendEmail = (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!IsEmailInvalid()) {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(email),
      };

      fetch(`api/Mail`, requestOptions)
        .then((response) => response.json() as Promise<Response>)
        .then((data) => {
          setResponse({
            ...response,
            success: data.success,
            responseText: data.responseText,
            active: true,
          });
        });
    }
  };

  React.useEffect(() => {
    if (response.active) {
      setTimeout(() => {
        setResponse({
          ...response,
          active: false,
        });
      }, 5000);
    }
  }, [response]);

  const HandleClientName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail({
      ...email,
      name: event.target.value,
    });
  };

  const HandleClientEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail({
      ...email,
      clientEmail: event.target.value,
    });
  };

  const HandleEmailSubject = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail({
      ...email,
      subject: event.target.value,
    });
  };

  const HandleEmailMessage = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setEmail({
      ...email,
      message: event.target.value,
    });
  };

  const IsEmailInvalid = (): boolean => {
    return (
      email.name.trim().length === 0 ||
      email.clientEmail.trim().length === 0 ||
      email.subject.trim().length === 0 ||
      email.message.trim().length === 0
    );
  };

  return (
    <section id="contact" className="body-section">
      <div className="container">
        <header>
          <h2 className="text-center section-title">Keep In Touch</h2>
          <p
            className="wow fadeInUp animated text-center"
            data-wow-delay="0.1s"
            style={{
              visibility: "visible",
              animationDelay: "0.1s",
              animationName: "fadeInUp",
            }}
          >
            Please don't hesitate send us even your most little interested
            question, we will be happy respond you.
          </p>
          <hr />
        </header>
        <form id="emailForm" className="row" onSubmit={SendEmail}>
          <div className="form-group col-md-6">
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Name"
              className="form-control"
              value={email.name}
              onChange={HandleClientName}
            />
            <div id="errorTxt-name" className="errorTxt"></div>
          </div>
          <div className="form-group col-md-6">
            <input
              id="mail"
              name="mail"
              type="email"
              placeholder="Email"
              className="form-control"
              value={email.clientEmail}
              onChange={HandleClientEmail}
            />
            <div id="errorTxt-mail" className="errorTxt"></div>
          </div>
          <div className="form-group col-md-12">
            <input
              id="subject"
              name="subject"
              placeholder="Subject"
              className="form-control"
              value={email.subject}
              onChange={HandleEmailSubject}
            />
            <div id="errorTxt-subject" className="errorTxt"></div>
          </div>
          <div className="form-group col-md-12">
            <textarea
              id="message"
              name="message"
              className="form-control"
              rows={10}
              placeholder="Message"
              value={email.message}
              onChange={HandleEmailMessage}
            ></textarea>
            <div id="errorTxt-message" className="errorTxt"></div>
          </div>
          <div className="form-group col-md-12">
            <input
              id="btnSendEmail"
              type="submit"
              value="Send"
              className="btn btn-lg btn-primary"
              disabled={IsEmailInvalid()}
            />
          </div>
          <div className="form-group col-md-12">
            <div
              id="alert-success"
              className={`alert alert-success not-active-alert ${
                response.active && response.success ? "active-alert" : ""
              }`}
            >
              {response.responseText}
            </div>
            <div
              id="alert-danger"
              className={`alert alert-danger not-active-alert ${
                response.active && !response.success ? "active-alert" : ""
              }`}
            >
              {response.responseText}
            </div>
          </div>
        </form>
        <div className="address">
          <div className="row">
            <div
              className="col-md-4 text-center wow zoomIn animated"
              style={{ visibility: "visible", animationName: "zoomIn" }}
            >
              <i className="fa fa-phone circled"></i>
              <span>+374 99 088 540</span>
            </div>
            <div
              className="col-md-4 text-center wow zoomIn animated"
              data-wow-delay="0.2s"
              style={{
                visibility: "visible",
                animationDelay: "0.2s",
                animationName: "zoomIn",
              }}
            >
              <i className="fa fa-envelope circled"></i>
              <span>studio@tribeca.am</span>
            </div>
            <div
              className="col-md-4 text-center wow zoomIn animated"
              data-wow-delay="0.4s"
              style={{
                visibility: "visible",
                animationDelay: "0.4s",
                animationName: "zoomIn",
              }}
            >
              <a
                href="https://goo.gl/maps/WeJjTxZddtr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa fa-globe circled"></i>
              </a>
              <span>Hakob Hakobyan 3</span>
              <span>Yerevan, Armenia</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
